const componentStyles = (theme) => ({
  bgDefault: {
    backgroundColor: theme.palette.background.default,
  },
});

export default componentStyles;
